import jwt from 'jsonwebtoken'
import { v4 as uuidv4 } from 'uuid'
import { DateUtils } from '../../common/date-utils'
import { isLiveChatAllowed } from '../../common/AccessHelper'
import { Configurations } from '../bff/configurations/dto/Configurations.dto'

interface LiveChatWindow {
  calls?: any[]
  (...args: any[]): void
}

declare global {
  interface Window {
    liveChat: LiveChatWindow
  }
}

export interface InfobipLiveChatConfig {
  widgetId: string
  securityKey: {
    id: string
    key: string
  },
}

export class InfobipLiveChat {
  static window: Window
  private static isInitializing = false

  static async startSession(configurations?: Configurations, operatorId?: string): Promise<void> {
    if (!isLiveChatAllowed(configurations) || !operatorId) return

    this.logout()

    const liveChatConfig = configurations?.communication?.liveChat?.infobip

    await this.init(liveChatConfig!)
    this.login(liveChatConfig!, operatorId)
    this.showLauncher()
  }

 static async init(liveChatConfig: InfobipLiveChatConfig): Promise<void> {
  if (this.isInitializing) return
  this.isInitializing = true

  return new Promise<void>((resolve, reject) => {
    window.liveChat?.('init', liveChatConfig.widgetId, (error: any, result: any) => {
      this.isInitializing = false

      if (error) {
        const errorObj = JSON.parse(error.message)

        // Error 1001 means live chat has already been initialized
        if (errorObj?.code === 1001) {
          this.showLauncher()
          return resolve()
        }

        return reject(error)
        }

        resolve()
      })
    })
  }

  static login(liveChatConfig: InfobipLiveChatConfig, operatorId: string) {
    const payload = {
      jti: uuidv4(),
      stp: 'externalPersonId',
      sub: operatorId,
      iss: liveChatConfig.widgetId,
      iat: DateUtils.getUnixTimestamp(),
      ski: liveChatConfig.securityKey.id,
    }

    const token = jwt.sign(
      payload,
      Buffer.from(liveChatConfig.securityKey.key, 'base64')
    )

    window.liveChat?.('auth', token)
  }

  static showLauncher() {
    window.liveChat?.('show_launcher')
  }

  static logout() {
    window.liveChat?.('hide_launcher')
    window.liveChat?.('hide')
    window.liveChat?.('logout')
  }
}
